import { useContext, useState } from "react";

import Button from "shared/components/inputs/mui/Button";
import Checkbox from "shared/components/inputs/checkbox/Checkbox";
import Context from "features/allocations/contexts/Context";
import EmployeeGridSelectionContext from "features/allocations/contexts/EmployeeGridSelectionContext";
import HStack from "shared/components/layout/stack/HStack";
import Tooltip from "shared/components/utils/tooltip/Tooltip";
import { useAllocations } from "features/allocations/api/useAllocations";

const SelectRows = () => {
    const employeeGridSelection = useContext(EmployeeGridSelectionContext);
    const checkboxTooltip = employeeGridSelection.allSelected ? "Deselect All Employees" : "Select All Employees";
    const buttonTooltip = employeeGridSelection.selectionIsEnabled ? "" : "Select Employees";
    const { query } = useContext(Context);
    const { getAllocationsUsersIds } = useAllocations();
    const [currentQuery, setCurrentQuery] = useState(null);

    return (
        <HStack align="center">
            <Checkbox
                title={checkboxTooltip}
                isSmallSize={true}
                checked={employeeGridSelection.allSelected}
                indeterminate={
                    !employeeGridSelection.allSelected &&
                    employeeGridSelection.selectedEmployeeIDs.length > 0
                }
                onChange={async (e) => {
                    const isNowChecked = e.target.checked;
                    if (isNowChecked) {
                        if (query === currentQuery){
                            employeeGridSelection.setSelectionIsEnabled(true);
                            employeeGridSelection.selectAllEmployeeIDs();
                        } else {
                            setCurrentQuery(query);
                            const idsResponse = await getAllocationsUsersIds(query);
                            employeeGridSelection.updateSelectableIDs(idsResponse);
                            employeeGridSelection.setSelectionIsEnabled(true);
                            employeeGridSelection.selectAllEmployeeIDs();
                        }
                    } else {
                        employeeGridSelection.setSelectionIsEnabled(false);
                        employeeGridSelection.deselectAllEmployeeIDs();
                    }
                }}
            />
            <Tooltip text={buttonTooltip}>
                <span>
                    <Button
                        disableRipple={true}
                        onClick={async () => {
                            const newSelectionState = !employeeGridSelection.selectionIsEnabled;
                            employeeGridSelection.setSelectionIsEnabled(newSelectionState);
                            if (!newSelectionState) {
                                employeeGridSelection.deselectAllEmployeeIDs();
                            } else if (query !== currentQuery) {
                                setCurrentQuery(query);
                                const idsResponse = await getAllocationsUsersIds(query);
                                employeeGridSelection.updateSelectableIDs(idsResponse);
                            }
                        }}
                        type={employeeGridSelection.selectionIsEnabled ? "link" : "secondary"}
                    >
                        {employeeGridSelection.selectionIsEnabled ? "Cancel" : "Select"}
                    </Button>
                </span>
            </Tooltip>
        </HStack>
    );
};

SelectRows.propTypes = {};
SelectRows.defaultProps = {};

export default SelectRows;
